import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Button, EmptyState } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";

class ErrorState extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "translate", id => this.props.intl.formatMessage({
      id: "error_state.".concat(id)
    }));
  }

  renderCta() {
    const {
      ctaText,
      onCtaClick: onCta,
      ctaLoading
    } = this.props;
    if (!onCta) return undefined;
    return /*#__PURE__*/_jsx(Button, {
      isLoading: ctaLoading,
      text: ctaText || this.translate('cta'),
      styling: Button.Styling.Filled,
      onClick: onCta
    });
  }

  render() {
    const {
      title,
      body
    } = this.props;
    return /*#__PURE__*/_jsx(EmptyState, {
      title: title || this.translate('title'),
      body: body || this.translate('body'),
      action: this.renderCta()
    });
  }

}

export default injectIntl(ErrorState);